import { Component, OnInit } from '@angular/core';
import { ThemeService } from "libs-frontend-micro-base";
import { PushXService } from 'modules/shared-postlogin/services/pushx.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomBackendLoggerService } from './../../../app/services/custom-backend-logger.service';
import { AppHelperService } from 'modules/app/services/app-helper.service';
import { AuthService } from 'modules/app/services/auth.service';
import { LoaderService } from '../../../app/services/loader.service';
import { CreateUserAnalyticsService } from '../../services/create-user-analytics.service';

@Component({
    selector: 'create-user-analytics',
    templateUrl: './create-user-analytics.template.html',
    styleUrls: ['./create-user-analytics.style.scss'],
    standalone: false
})
export class CreateUserAnalytics implements OnInit{
    public imageBasePath: string = IMAGES_BASEPATH;
    progressBar:HTMLElement;
    widthOfProgressBar: number = 0;
    currentTheme:any;
    params: any;

    themeService;
    constructor(
        private route: ActivatedRoute, 
        private pushXService : PushXService,
        private customBackendLoggerService : CustomBackendLoggerService,
        private appHelperService: AppHelperService,
        private router: Router,
        private authService: AuthService,
        private loaderService: LoaderService,
        private createUserAnalyticsService: CreateUserAnalyticsService,
    ) { 
        this.themeService = new ThemeService();
        this.currentTheme = this.themeService.getActiveTheme().meta;
    }

    ngOnInit() {
        this.loaderService.hideLoader();
        this.progressBar = document.getElementById("progressBar");
        this.setProgessBarWidth(20);
        this.params = this.route.snapshot.params;
        const {userId, orgId, redirectRoute, pubnubEventType} = this.createUserAnalyticsService.getUAMetadata();
        const userData = this.authService.getUserData();
        let channelId:string = this.getChannelId(pubnubEventType);
        
        if(userId && orgId) {
            this.pushXService.grantByOrgId(orgId, this.params.spaceid).toPromise().then(() => {
                this.setProgessBarWidth(40);
                const pushXConnection = this.pushXService.getPushXConnection(orgId);
                pushXConnection.on({ userid: userId, orgid: orgId, channel: channelId }, (sysevent) => {
                    const eventBody = sysevent?.events?.body || {};
                    this.pushXLogger(userData, 'TYPE=SYSTEM_EVENTS, Preview Product', eventBody, true).catch(e => { throw e; });
                    if((eventBody.productcode == this.params.productcode || eventBody.productCode == this.params.productcode)
                        && eventBody.userid == userId) {
                        if (eventBody.status == "success") {
                            this.setProgessBarWidth(100);
                            let urlSegments = redirectRoute.url.split('/').filter(Boolean);
                            urlSegments = urlSegments.map(segment => decodeURIComponent(segment));
                            this.router.navigate(urlSegments, { queryParams: redirectRoute.queryParams });
                        } else if(eventBody.status == "error") {
                            this.appHelperService.navigateToDashboardApp(['error']);
                        }
                    }
                });

                pushXConnection.on({ channel: "pushx_status" }, (subscriptionStatus) => {
                    if(subscriptionStatus.category === 'PUSHX' && subscriptionStatus.type === 'CHANNEL_SUBSCRIPTION') {
                        if(subscriptionStatus.status === 'SUCCESS') {
                            this.setProgessBarWidth(60);
                            this.createUserAnalyticsService.userProductEntitlement(this.params.spaceid, this.params.productcode)
                            .subscribe(() => {
                                if(this.widthOfProgressBar < 80) this.setProgessBarWidth(80);
                            });
                        } else if(subscriptionStatus.status === 'ERROR') {
                            throw new Error(JSON.stringify(subscriptionStatus));
                        }
                    }
                });
            }).catch((err) => {
                console.log('error', err);
            });
        } else {
            this.appHelperService.navigateToDashboardApp(['error']);
        }
    }

    async pushXLogger(userData: any, context: string, message: string, success: boolean) {
        const logObj: any = {
            message, context,
            extUserId: userData.extUserId,
            role: userData.role,
            status: !success ? 'error' : 'success'
        };
        await this.customBackendLoggerService.logInfoToBackend(logObj).toPromise();
    }
    setProgessBarWidth(width: number) {
        this.widthOfProgressBar = width;
        this.progressBar.style.width = this.widthOfProgressBar + '%';
    }

    /**
     * @param pubnubEventType 
     * @returns channelId
     * @description This function is used to get the channelId based on the pubnubEventType
     * issue: https://3.basecamp.com/4489886/buckets/20201480/messages/7080965318#__recording_7654396267
     * Fix suggestion: https://3.basecamp.com/4489886/buckets/20201480/messages/7080965318#__recording_7731460768
     */
    getChannelId(pubnubEventType: string) {
        let channelId = 'systemevents.';
        if(pubnubEventType === 'NORMAL_CLASS') {
            channelId += 'PRODUCT.USERDATA_ADD';
        } else if(pubnubEventType === 'GROUP_ENBALED_OR_CONTEXT_CLASS') {
            channelId += 'CLASS_AGGREGATION.USER_ENROLLMENT_ADD';
        }
        return channelId;
    }
}